import React from "react";
import { Door } from "../../1/types";
import DoorRow from "./DoorRow";

interface LockType {
  id: number;
  type_code: string;
  name: string;
  icon_path: string | null;
  display_order: number;
  is_active: number | boolean;
}

interface DoorsTableProps {
  doors: Door[];
  disabled?: boolean;
  backendUrl: string;
  findDoor: (name: string) => Door | undefined;
  handleRemoveDoorx: (id: number) => void;
  handleInputChangeAmont: (index: number, value: number, field: string, step: number) => void;
  handleDoorChange: (index: number, field: keyof Door, value: string | number) => void;
  handleInputChange: (
    index: number,
    field: keyof Door,
    value: string | number,
    numb: number,
    step: number,
    name: string,
    innen: number,
    auben: number
  ) => void;
  lockTypes: LockType[];
  taxRate?: number;
}

const DoorsTable: React.FC<DoorsTableProps> = ({
  doors,
  disabled,
  backendUrl,
  findDoor,
  handleRemoveDoorx,
  handleInputChangeAmont,
  handleDoorChange,
  handleInputChange,
  lockTypes,
  taxRate,
}) => {
  return (
    <div id="special-options" className="specialOptions">
      <div style={{ width: "100%" }}>
        <div
          className="doors-table-header"
          style={{
            backgroundColor: "#005CA9",
            textAlign: "center",
            display: "flex",
            justifyContent: "space-between",
            color: "#FFFFFF",
            fontWeight: "bold",
          }}
        >
          <div className="is-size-6">Zylinder konfigurieren</div>
        </div>
        <div
          className="doors-header"
          style={{
            textAlign: "start",
            padding: "1%",
            alignItems: "center",
          }}
        >
          <div className="col-delete" style={{ width: 48, display: "flex", alignItems: "center", justifyContent: "center" }} />

          <div className="col-name is-size-6 has-text-weight-bold" style={{ color: "black" }}>
            Bezeichnung
          </div>

          <div className="col-amount is-size-6 has-text-weight-bold" style={{ textAlign: "center", color: "black" }}>
            Anzahl
          </div>

          <div className="col-type is-size-6 has-text-weight-bold" style={{ paddingLeft: "42px", color: "black" }}>
            Typ
          </div>

          <div className="door-col-net is-size-6 has-text-weight-bold" style={{ textAlign: "right", paddingRight: "12px", color: "black" }}>
            Netto
          </div>

          <div className="door-col-gross is-size-6 has-text-weight-bold" style={{ textAlign: "right", paddingRight: "12px", color: "black" }}>
            <span className="tablet-header">Preis</span>
            <span className="desktop-header">Brutto</span>
          </div>
        </div>
        {doors.map((door, index) => (
          <DoorRow
            key={`${door.doorName}-${index}`}
            door={door}
            index={index}
            disabled={disabled}
            backendUrl={backendUrl}
            findDoor={findDoor}
            handleRemoveDoorx={handleRemoveDoorx}
            handleInputChangeAmont={handleInputChangeAmont}
            handleDoorChange={handleDoorChange}
            handleInputChange={handleInputChange}
            lockTypes={lockTypes}
            taxRate={taxRate}
          />
        ))}
      </div>
    </div>
  );
};

export default DoorsTable;
